import Button from "olive-react-myoneui/lib/Button";
import { useSelector, useDispatch } from "react-redux";
import { setUserItemApprovalData } from "../../reducers/userItemApprovalSlice";
import { useEffect, useState } from "react";
/* This component renders a button called I'm interested. When clicking the button, a modal opens
   by setting the required data in redux store with the help of reducer 'userItemApprovalSlice.js'.
*/
function IamInterestedButton({
  className = false,
  itemId,
  itemType = "booking_event",
  item,
}) {
  const dispatch = useDispatch();
  const existingApprovalIds = useSelector(
    (state) => state.userItemApproval.existingApprovalIds
  );
  const [alreadyInterested, setAlreadyInterested] = useState(false);

  const iamInterestedModalTitle =
    "Are you sure want to continue? This will create the interest in this course and line managers must approve your request";

  useEffect(() => {
    if (item && existingApprovalIds.includes(item.item_id)) {
      setAlreadyInterested(true);
    }
  }, [item, existingApprovalIds]);

  const openModal = () => {
    dispatch(
      setUserItemApprovalData({
        showIamInterestedModal: true,
        currentItem: { itemId, itemType: "4", itemName: item.item_name },
        apiRequestLoading: false,
        apiRequestTriggered: false,
        hideCancelButton: false,
        iamInterestedModalTitle,
      })
    );
    return;
  };

  return (
    <Button
      id={"iAmInterested-" + itemId}
      disabled={alreadyInterested}
      variant="outline"
      className={
        (className !== false ? className : "w-100 mb-3") +
        " cart_btn_" +
        itemType +
        "_" +
        itemId
      }
      size="md"
      onClick={openModal}
    >
      {"I'm interested"}
    </Button>
  );
}

export default IamInterestedButton;
